import React from 'react'

const relatedPages = (props) => {
  if (!props.relatedPages) return null
  return props.relatedPages.map((item, key) => {
    const date = new Date(item.date).toString().split(/:\d\d /)
    if (!item.description || !item.link || !item.title) return null
    return (
      <div key={key} className='panel panel-primary'>
        <div className='panel-body'>
          {item.image && (
            <img className='img-responsive' src={item.image} />
          )}
          <h3 className='mb-0 product-title'>
            <a href={item.link} data-toggle='modal.pane'>{item.title}</a>
          </h3>
          <p className='small text-muted mb-0 product-description'>{item.description}</p>
          {date[1] && (
            <p className='small text-muted'>{date[0]}</p>
          )}
        </div>
      </div>
    )
  })
}

export default relatedPages



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/content/relatedPages.jsx